import SignUp from "../../components/features/sign-up/SignUp";

const SignUpPage = () => {
  return <SignUp />;
};

export default SignUpPage;
